import { Link } from 'wouter';

/* The site footer. `tone` matches it to the page above it (site-nav.css):
   light paper by default, black, City's green or Code's brown. */
export type FooterTone = 'light' | 'dark' | 'green' | 'sage' | 'brown';

export function Footer({ tone = 'light' }: { tone?: FooterTone }) {
  return (
    <footer class={`footer footer--${tone}`}>
      <div class="footer__container">
        <div class="footer__grid">
          <div class="footer__brand">
            <Link href="/" class="footer__logo">
              <img
                src="/giraffe.svg"
                alt="Giraffe"
                class="footer__logo-image"
              />
              <span>Giraffe</span>
            </Link>
            <p class="footer__tagline">
              Operating system for real estate development.
            </p>
          </div>

          <div class="footer__section">
            <h4>Product</h4>
            <ul class="footer__links">
              <li>
                <Link href="/plugins" class="footer__link">
                  Plugins
                </Link>
              </li>
              {/* <li>
                <Link href="/enterprise" class="footer__link">
                  Enterprise
                </Link>
              </li> */}
              <li>
                <a
                  href="https://intercom.help/giraffe-knowledgebase-v6/en/articles/12038658-the-giraffe-javascript-sdk"
                  class="footer__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  SDK docs
                </a>
              </li>
            </ul>
          </div>

          <div class="footer__section">
            <h4>Company</h4>
            <ul class="footer__links">
              <li>
                <Link href="/blog" class="footer__link">
                  Blog
                </Link>
              </li>
              <li>
                <Link href="/case-studies" class="footer__link">
                  Case studies
                </Link>
              </li>
              <li>
                <Link href="/careers" class="footer__link">
                  Careers
                </Link>
              </li>
              <li>
                <Link href="/contact" class="footer__link">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div class="footer__section">
            <h4>Find us</h4>
            <ul class="footer__links">
              <li>
                <a
                  href="https://www.linkedin.com/company/giraffebuild/"
                  class="footer__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UC46_fEHQOvCiphbChuvrXXg/"
                  class="footer__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  YouTube
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="footer__bottom">
          <p class="footer__copyright">
            © {new Date().getFullYear()} Giraffe. All rights reserved.
          </p>
          <div class="footer__legal">
            <Link href="/legal/eula">EULA</Link>
            <Link href="/legal/customer-app-policy">Customer App Policy</Link>
            <Link href="/legal/privacy">Privacy</Link>
            <a href="https://intercom.help/giraffe-knowledgebase-v6/en/articles/12499611-security-overview" target="_blank" rel="noopener noreferrer">Security</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
